module.exports = __webpack_public_path__ + "img/letter_icon5.1faef874.png";